import React from "react";
import { ModalComponent } from "..";
import {
  PureCreateProfile,
  SuggestedForum,
  ContentPreference,
  FavouriteTeams,
} from ".";
import { registerModal, successModal } from "../../state/action";
import { useDispatch } from "react-redux";
import StepProgressBar from "react-step-progress";
import "react-step-progress/dist/index.css";

const RegisterModal = ({ show }) => {
  const dispatch = useDispatch();
  return (
    <ModalComponent
      width={1000}
      visible={show}
      onCancel={() => dispatch(registerModal())}
    >
      <StepProgressBar
        startingStep={0}
        previousBtnName={"< Back to Login"}
        nextBtnName={"Next Step >"}
        onSubmit={() => {
          dispatch(registerModal());
          dispatch(successModal());
        }}
        steps={[
          {
            label: "",
            subtitle: "",
            name: "step 1",
            content: <PureCreateProfile />,
          },
          {
            label: "",
            subtitle: "",
            name: "step 2",
            content: <SuggestedForum />,
          },
          {
            label: "",
            subtitle: "",
            name: "step 3",
            content: <ContentPreference />,
          },
          {
            label: "",
            subtitle: "",
            name: "step 4",
            content: <FavouriteTeams />,
          },
        ]}
      />
    </ModalComponent>
  );
};

export default RegisterModal;
